import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { StyledLabel } from '../Auth/LoginForm';
import { Form, Required } from '../Auth/RegisterForm';
import { Select } from '../../Zemplin/General/Select';
import { StyledInput } from '../Auth/WarehouseRegisterForm';
import { FormInput } from '../Form/FormInput';
import { DsiCheckBox } from '../General/Checkbox';

interface Props {
  name: string;
  ico: string;
  dic: string;
  icdph: string;
  onChange: (e) => void;
  isB2B?: boolean;
  lang: string;
  problems?: any;
  handleVatPayerChange: any;
  vat_payer: boolean;
}

function CompanyInfo({
  name,
  ico,
  dic,
  icdph,
  onChange,
  isB2B,
  lang,
  problems,
  handleVatPayerChange,
  vat_payer,
}: Props) {
  const { icoProblem, dicProblem, icdphProblem } = {
    icoProblem: problems?.ico,
    dicProblem: problems?.dic,
    icdphProblem: problems?.ic_dph || problems?.icdph,
  };

  return (
    <Wrapper isB2B={isB2B}>
      {(!!name || !isB2B) && (
        <StyledInput marginBottom={isB2B ? 0 : 16}>
          <FormInput
            justText={isB2B}
            name={'company'}
            type="text"
            label={__('Názov spoločnosti')}
            value={name}
            required={isB2B}
            onChange={onChange}
          />
        </StyledInput>
      )}
      {(!!ico || !isB2B) && (
        <StyledInput marginBottom={isB2B ? 0 : 16}>
          <FormInput
            justText={isB2B}
            name={'ico'}
            type="text"
            required={isB2B}
            label={__('IČO')}
            value={ico}
            onChange={onChange}
            validMessage={icoProblem}
          />
        </StyledInput>
      )}
      {(!!dic || !isB2B) && (
        <StyledInput marginBottom={isB2B ? 0 : 16}>
          <FormInput
            justText={isB2B}
            name={'dic'}
            type="text"
            required={isB2B}
            label={__('DIČ')}
            value={dic}
            onChange={onChange}
            validMessage={dicProblem}
          />
        </StyledInput>
      )}
      {lang === 'sk' && (!!icdph || !isB2B) && (
        <StyledInput marginBottom={16}>
          <FormInput
            justText={isB2B}
            name={'icdph'}
            type="text"
            required={isB2B}
            label={__('IČ DPH')}
            value={icdph}
            marginBottom={16}
            onChange={onChange}
            validMessage={icdphProblem}
          />
        </StyledInput>
      )}
      {lang === 'cz' && (
        <StyledInput marginBottom={16}>
          <DsiCheckBox
            name="vat_payer"
            onClick={handleVatPayerChange}
            selected={vat_payer}
            label={__('Platca DPH')}
          />
        </StyledInput>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)``;

export { CompanyInfo as DsiCompanyInfo };
